<div *ngIf="displayValidationError()" class="validation-error">
    {{message}}
</div>